var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaymentMethodCash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3394 6.91044C12.3394 9.90907 9.90858 12.3399 6.90996 12.3399C3.91133 12.3399 1.48047 9.90907 1.48047 6.91044C1.48047 3.91182 3.91133 1.48096 6.90996 1.48096C9.90858 1.48096 12.3394 3.91182 12.3394 6.91044Z",
    stroke: "#2C2E30"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.91016 3.29053V10.5298",
    stroke: "#2C2E30",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.55521 4.60693H6.08726C5.7818 4.60693 5.48886 4.72827 5.27287 4.94426C5.05689 5.16025 4.93555 5.45319 4.93555 5.75864C4.93555 6.0641 5.05689 6.35704 5.27287 6.57302C5.48886 6.78901 5.7818 6.91035 6.08726 6.91035H7.73256C8.03801 6.91035 8.33095 7.03169 8.54694 7.24768C8.76293 7.46367 8.88427 7.75661 8.88427 8.06206C8.88427 8.36751 8.76293 8.66046 8.54694 8.87644C8.33095 9.09243 8.03801 9.21377 7.73256 9.21377H4.93555",
    stroke: "#2C2E30",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentMethodCash);
export default __webpack_public_path__ + "static/media/payment_method_cash.d30ec49d.svg";
export { ForwardRef as ReactComponent };